export default "__VITE_ASSET__Cb1VxndF__"